export const calculateTotalGST = (invoice) => {
  const items = invoice?.invoiceId?.startsWith("RT")
    ? invoice?.returnitems
    : invoice?.items;

  return (items || []).reduce((totalGST, item) => {
    const igst = parseFloat(item.igst) || 0;
    const sgst_utgst = parseFloat(item.sgst_utgst) || 0;
    const cess = parseFloat(item.cess) || 0;

    return totalGST + igst + sgst_utgst + cess;
  }, 0);
};

export const calculateTotalGSTPercentage = (item) => {
  const igst = parseFloat(item.igst) || 0;
  const cgst = parseFloat(item.cgst) || 0;
  const sgst_utgst = parseFloat(item.sgst_utgst) || 0;
  const cess = parseFloat(item.cess) || 0;

  return igst + cgst + sgst_utgst + cess;
};

export const calculateTotalGSTAmount = (item) => {
  const totalGSTPercentage = calculateTotalGSTPercentage(item);
  const salePrice = parseFloat(item.salePrice) || 0;

  return Math.round((totalGSTPercentage / 100) * salePrice);
};
